import { signOut } from "next-auth/react";
import { commonAction } from "./actions";
import { serverAction } from "./ServerActions";
import { toast } from "@libs/helper/toast";
// import { useData } from "@providers/context";

type RequestMethod = "get" | "post" | "put" | "patch" | "delete";

type reqProps = {
  type: RequestMethod;
  endPoint: string;
  data?: object;
  headersReq?: object;
  headersReqWithSession?: object;
  session?: any;
  update?: any;
  noSession?: boolean;
};

export async function mutateAction({
  type,
  endPoint,
  data = {},
  session,
  headersReq,
  update,
  headersReqWithSession,
  noSession = false,
}: reqProps) {
  // const { setSessionExpired } = useData();
  const getData = async (customSession?: any) => {
    try {
      const response = await commonAction({
        type,
        endPoint,
        ...(noSession ? {} : { session: customSession || session }),
        data,
        headersReq,
        headersReqWithSession,
      });

      if (response?.error?.status === 401) {
        console.log("token expired");
        const data = await refreshToken();
        if (data) return data;
      }
      if (response?.error) {
        console.error(`${JSON.stringify(response?.error)} ${endPoint}`);
        throw new Error(response.error?.heading, {
          cause: response?.error?.message,
        });
      }
      return response;
    } catch (error: any) {
      // Check for network-related errors
      if (
        error.message?.includes("Network is offline") ||
        error.message?.includes("Network connection lost") ||
        (error.name === "TypeError" && error.message === "Failed to fetch")
      ) {
        // Re-throw with a user-friendly message
        throw new Error("Network Error", {
          cause: "Please check your internet connection and try again.",
        });
      }
      // Re-throw other errors
      throw error;
    }
  };

  async function refreshToken() {
    const response = await serverAction({ session });
    if (response?.status === 401) {
      // setSessionExpired(true);
      toast("Session expired", { type: "error" });
      signOut();
    } else if (!response?.error) {
      if (update) {
        update(response);
        console.log("token updated");
      }
      const data: any = await getData(response);
      return data;
    } else if (response.error) {
      toast(response.error, { type: "error" });
      return null;
    }
  }

  const responseData = await getData();

  return responseData;
}
